import AuthPage from './AuthPage'
import {fullPageLayoutConfig} from '../layout.helper'

export const AuthPageConfig = {
  settings: {
    layout: fullPageLayoutConfig,
  },
  routes: [
    {
      path: '/auth',
      component: AuthPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/login/AuthPageConfig.js